<div class="row col-12 p-0 m-0 main-page-section " *ngIf="isLoadedData">
  <div class="col-12 p-0 employee-section">
    <div class="col-height">

      <div class="breadcrumbs-section pl-2 ml-5">
        <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
        <img src="../../assets/images/seperator.png">
        <span class="prev-page pr-2 pl-2 prev" routerLink="/company">Companies</span>
        <img src="../../assets/images/seperator.png">
        <span class="curr-page pl-2 breadcrumbs-section-font current">{{titleText}} Company</span>
      </div>

      <div class="add-company-layout">
        <div class="row">
          <div class="col-12">
            <h1 class="font-bold">{{titleText}} Company</h1>

          </div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-10">
            <h2 class="font-bold">Company Details</h2>
          </div>
          <div class="col-2" *ngIf="edit"><button type="button" class="remove-button">Remove Company</button></div>
        </div>

        <form [formGroup]="Form" (ngSubmit)="submit()" *ngIf="isLoaded">
          <div class="row mt-3">
            <div class="col-4">
              <input type="text" [ngClass]="cmpName?'textbox-onselect':'textbox-style'"
                class="search-line  pl-4 placeholder-text " [placeholder]="!cmpName ? 'Company Name' : ''"
                (click)="enterName('companyName')" formControlName="companyName" (blur)="enterName('companyName')"
                (ngModelChange)="inputModelChange(1,'companyName')">
              <label *ngIf="cmpName" class="form-lable">Company Name</label>
              <div *ngIf="submitted && f.companyName.errors" class="error-fields">
                <div *ngIf="f.companyName.errors.required">*Company Name is required</div>
                <div *ngIf="f.companyName.errors.pattern">*Company Name is Invalid</div>
              </div>
            </div>
            <div class="col-4">
              <input type="text" [ngClass]="cmpWebsite?'textbox-onselect':'textbox-style'"
                class="search-line  pl-4 placeholder-text " [placeholder]="!cmpWebsite ? 'Official Website' : ''"
                (click)="enterName('companyWebsite')" formControlName="companyDomain"
                (blur)="enterName('companyWebsite')" (ngModelChange)="inputModelChange(1,'companyWebsite')">
              <label *ngIf="cmpWebsite" class="form-lable">Official Website</label>
              <div *ngIf="submitted && f.companyDomain.errors" class="error-fields">
                <div *ngIf="f.companyDomain.errors.required">*Official Website is required</div>
                <div *ngIf="f.companyDomain.errors.pattern">*Invalid website</div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group floating_form_field mb-0 w-100">
                <input class="form-control w-100" autocomplete="off" (click)="d6.toggle()"
                  [placeholder]="!mtsDate ? 'Agreement Expiry Date' : ''" (clickOutside)="onClickedOutside($event)"
                  [autoClose]="'inside'" (keypress)="$event.preventDefault()" (click)="enterName('contexpdate')"
                  (dateSelect)="updateSelectedDate($event)" id="agreementexpirydate" type="text"
                  formControlName="agreementexpirydate" [(ngModel)]="agreementexpirydate" ngbDatepicker container='body'
                  #d6="ngbDatepicker" [minDate]="minFromDate">
                <label>Agreement Expiry Date</label>
              </div>
              <div *ngIf="submitted && f.agreementexpirydate.errors" class="error-fields">
                <div *ngIf="f.agreementexpirydate.errors.required">*Agreement Expiry Date is required</div>
              </div>
            </div>
            <!-- <div class="col-4">
              <input type="text" [ngClass]="cmpEmail?'textbox-onselect':'textbox-style'"
                class="search-line  pl-4 placeholder-text " [placeholder]="!cmpEmail ? 'Official Email Domain' : ''"
                (click)="enterName('cmpEmail')" formControlName="companyOfficalEmailId" (blur)="enterName('cmpEmail')"
                (ngModelChange)="inputModelChange(1,'cmpEmail')">
              <label *ngIf="cmpEmail" class="form-lable">Official Email Domain</label>
              <div *ngIf="submitted && f.companyOfficalEmailId.errors" class="error-fields">
                <div *ngIf="f.companyOfficalEmailId.errors.required">*Official Email id is required</div>
              </div>
            </div> -->
          </div>
          <div class="row" style="margin-top: 20px;padding-left: 15px;">
            <p class="" style="font-size: 20px;color: rgba(64,64,64,0.6);">Employee Self Verification</p>
            <label class="switch" style="position: relative;margin-left: 2%;">
              <input formControlName="isSelfVerified" [(ngModel)]="isSelfVerified"
                (change)="checkSelfVerfification($event)" type="checkbox" class="custom-control-input"
                id="customSwitches" />
              <span class="slider round"></span>
            </label>
          </div>

          <div class="row mt-3">
            <div class="col-4" formArrayName="companyOfficalEmailId"
              *ngFor="let item of companyOfficalEmailId.controls; let i=index">
              <div [formGroupName]="i">
                <input type="text" [ngClass]="cmpEmail?'textbox-onselect':'textbox-style'"
                  class="search-line  pl-4 placeholder-text "
                  [placeholder]="!cmpEmail ? 'Official Email Domain (@example.com)' : ''"
                  (click)="enterName('cmpEmail')" formControlName="officalEmail" (blur)="enterName('cmpEmail')"
                  (ngModelChange)="inputModelChange(1,'cmpEmail')" (keyup)="addToEmailList()">
                <label *ngIf="i >= 1" class="deleteBox" (click)="removeEmailBox(i)">Delete</label>
                <label *ngIf="cmpEmail" class="form-lable">Official Email Domain</label>
                <div *ngIf="submitted && item.controls.officalEmail.errors" class="error-fields">
                  <div *ngIf="item.controls.officalEmail.errors.required">*Official Email id is required</div>
                  <div *ngIf="item.controls.officalEmail.errors.email">*Invalid Official Email id</div>
                  <div *ngIf="item.controls.officalEmail.errors.pattern">*Invalid Domain</div>
                </div>
              </div>
            </div>
            <div class="row mt-3" *ngIf="domainCount <=2" (click)="addDomain();" style="cursor: pointer;">
              <div class="col-4">
                <button type="button" class="button-add-admin" style="width: max-content;">+ Add Another Domain</button>
              </div>
              <div class="col-8"></div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12">
              <p>Building Name(s)</p>
            </div>
          </div>
          <div class="row">
            <div class="col-8 customPop">

              <div style="display: inline;" class="before-select" *ngFor="let item of selectedBuilding | slice:0:3">
                {{item.parkBuildingName}} <span style="margin-left: 10px;cursor: pointer;"
                  (click)="selectedBuildingDropDown(item)"><img src="assets/images/company/cross.png"></span></div>
              <div style="display: inline;" class="before-select" *ngIf="selectedBuilding.length > 3">
                <span>+{{selectedBuilding.length - 3}} More</span>
              </div>
              <div class="pt-3 pb-3 d-flex " [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual"
                #p="ngbPopover" (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                popoverClass='dash-popover dashboard-popover1' class="pt-3  pr-0 dropdown-input">
                <span class="d-flex justify-content-end"><img src="/assets/images/Path.png"
                    class="padding-left-image pr-3 justify-content-between" /></span>

                <div>
                  <ng-template #popContent>
                    <div class="popupHeader">
                      <img src="../../assets/images/search.png">
                      <input type="text" placeholder='Search' [(ngModel)]="buildSearch"
                        [ngModelOptions]="{standalone: true}" />
                    </div>

                    <div class="text-right clear-all-button" (click)="clearSelect()"
                      style="cursor: pointer;margin-right:10px">Clear All</div>

                    <div class="template p-0 ">
                      <div class="dashboard-popover1 ">
                        <div class="d-flex justify-content-between ">
                          <div class="pl-3 pr-3 pb-3 " style="width: 100%;margin-top: 10px;">
                            <div style="cursor: pointer;display: flex;justify-content: space-between;"
                              *ngFor="let company of buildings | filter: buildSearch:'parkBuildingName' ;let i=index"
                              (click)="selectedBuildingDropDown(company)">
                              <div>
                                {{company?.parkBuildingName}}
                              </div>
                              <div class="col-1">
                                <img src="/assets/images/tick.png" *ngIf="checkBuilding(company)" class=""
                                  loading="lazy" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div *ngIf="submitted && selectedBuilding.length <=0" class="error-fields">
                <div *ngIf="selectedBuilding.length <=0">*Building is required</div>
              </div>
            </div>
            <div class="col-4"></div>
          </div>

          <div class="row" style="margin-top: 40px;padding-left: 15px;">
            <p class="" style="font-size: 20px;color: rgba(64,64,64,0.6);">Enable VMS for 24 hours</p>
            <label class="switch" style="position: relative;margin-left: 2%;">
              <input formControlName="isApprovedTimeExtension" [(ngModel)]="isApprovedTimeExtension"
                (change)="checkcompanyApprovalOverTime($event)" type="checkbox" class="custom-control-input"
                id="customSwitches" />
              <span class="slider round"></span>
            </label>
          </div>

          <div class="row mt-5">
            <div class="col-12">
              <h3>Alloted Parking Details <span>(Optional)</span></h3>
            </div>
          </div>

          <div class="row mt-4 mb-4">
            <div class="col-5">
              <div class="row">
                <div class="col-3 blue-text pt-3">
                  2 Wheeler
                </div>
                <div class="col-4 value-setter"
                  style="display: flex;justify-content: space-between;align-items: center;">
                  <button type="button" (click)="addSubValue('sub','twoW')">-</button>
                  <p class="mt-3 pt-0 pl-1 pr-1"><input type="number" [align]="'center'"
                      formControlName="twowhellerVechicleCount" class="inputPark"
                      (keyup)="changeValueParking($event.target.value, 'twoW')"></p><button type="button"
                    (click)="addSubValue('add','twoW')">+</button>
                </div>
              </div>
            </div>
            <div class="col-5">
              <div class="row">
                <div class="col-3 blue-text pt-3">
                  4 Wheeler
                </div>
                <div class="col-4 value-setter"
                  style="display: flex;justify-content: space-between;align-items: center;">
                  <button type="button" (click)="addSubValue('sub','fourW')">-</button>
                  <p class="mt-3 pt-0 pl-1 pr-1"><input type="number" [align]="'center'"
                      formControlName="fourwhellerVechicleCount" class="inputPark"
                      (keyup)="changeValueParking($event.target.value, 'fourW')"></p><button type="button"
                    (click)="addSubValue('add','fourW')">+</button>
                </div>
              </div>
            </div>
            <div class="col-2"></div>
          </div>

          <hr>

          <div class="row" style="margin-top: 40px;padding-left: 15px;">
            <p class="" style="font-size: 20px;color: rgba(64,64,64,0.6);">Enable Conference Room Onboarding</p>
            <label class="switch" style="position: relative;margin-left: 2%;">
              <input formControlName="enableRoomOnboarding" [(ngModel)]="enableRoomOnboarding"
                (change)="allowOnboarding($event)" type="checkbox" class="custom-control-input" id="customSwitches" />
              <span class="slider round"></span>
            </label>
          </div>

          <div class="row mt-4 mb-4" *ngIf="enableRoomOnboarding">
            <div class="col-7">
              <div class="row">
                <div class="col-3 blue-text pt-3">
                  Max Conference Room
                </div>
                <div class="col-4 value-setter"
                  style="display: flex;justify-content: space-between;align-items: center;">
                  <button type="button" (click)="addSubValueMaxConfRoom('sub','twoW')"
                    [disabled]="isDisabledMaxConfRoom || isConferanceRoomReduces">-</button>
                  <p class="mt-3 pt-0 pl-1 pr-1">
                    <input type="number" [align]="'center'" formControlName="maxRoomOnBoarding" class="inputPark"
                      (keyup)="changeValueMaxConfRoom($event.target.value, 'twoW')" readonly>
                  </p>
                  <button type="button" (click)="addSubValueMaxConfRoom('add','twoW')">+</button>
                </div>
              </div>
            </div>
          </div>


          <div class="row" style="margin-top: 40px; margin-bottom: 40px;">
            <div class="col-md-3 col-sm-12 col-12">
              <div class="d-flex align-items-center">
                <p class="" style="font-size: 20px;color: rgba(64,64,64,0.6); margin-top: 10px; margin-bottom: 0px;">
                  Allow VMS</p>
                <label class="switch" style="position: relative;margin-left: 5%;">
                  <input formControlName="isVmsAllowed" [(ngModel)]="isVmsAllowed" (change)="allowVmsAccessData($event)"
                    type="checkbox" class="custom-control-input" id="customSwitches" />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="col-md-3 col-sm-12 col-12">
              <div *ngIf="isVmsAllowed" class="d-flex align-items-center">
                <p class="" style="font-size: 20px;color: rgba(64,64,64,0.6); margin-top: 10px; margin-bottom: 0px;">
                  Allow Walk-in</p>
                <label class="switch" style="position: relative;margin-left: 5%;">
                  <input formControlName="isWalkInAllowed" [(ngModel)]="isWalkInAllowed"
                    (change)="allowWalkInAccessData($event)" type="checkbox" class="custom-control-input"
                    id="customSwitches" />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-12">
              <div *ngIf="isWalkInAllowed && isVmsAllowed" class="d-flex align-items-center">
                <p class="" style="font-size: 20px;color: rgba(64,64,64,0.6); margin-top: 10px; margin-bottom: 0px;">
                  Approval Required</p>
                <label class="switch" style="position: relative;margin-left: 5%;">
                  <input formControlName="isPreApprovalReqd" [(ngModel)]="isPreApprovalReqd"
                    (change)="allowForApproval($event)" type="checkbox" class="custom-control-input"
                    id="customSwitches" />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>



          <!-- <div class="mt-3 row" *ngIf="isVmsAllowed">
            <div class="col-5 d-flex">
              <input type="radio" class="mr-2 mt-1" value="1" formControlName="vmsAllowType"
                (change)="onVmsAccessChange($event.target.value, i)" [checked]="vmsAllowType=='1'">
              <label for="Allow Walkins" class="radio-label ">Allow Walkins</label>
              <input type="radio" class="mr-2 ml-5 mt-1" value="2" formControlName="vmsAllowType"
                (change)="onVmsAccessChange($event.target.value, i)" [checked]="vmsAllowType=='2'">
              <label for="Walkin Approval" class="radio-label">Walkin Approval</label>
            </div>
            <div class="col-7"></div>
          </div> -->

          <div class="row mt-4 mb-4" *ngIf="isVmsAllowed">
            <div class="col-7">
              <div class="row">
                <div class="col-3 blue-text pt-3">
                  Security Points
                </div>
                <div class="col-4 value-setter"
                  style="display: flex;justify-content: space-between;align-items: center;">
                  <button type="button" (click)="updateValueSecurityPoints('sub','twoW')"
                    [disabled]="isDisabledSubmit">-</button>
                  <p class="mt-3 pt-0 pl-1 pr-1">
                    <input type="number" [align]="'center'" formControlName="securityPointCount" class="inputPark"
                      readonly>
                  </p>
                  <button type="button" (click)="updateValueSecurityPoints('add','twoW')"
                    [disabled]="isDisabledSubmit">+</button>
                </div>
              </div>
              <!-- <button (click)="generateSecurityPointForm()">Create</button> -->
            </div>
          </div>

          <div *ngIf="isVmsAllowed">
            <div class="row mt-4" *ngIf="securityDetails.controls.length>0">
              <div class="col-12">
                <h2 class="mb-0 pb-0">Security Information(s)</h2>
              </div>
            </div>

            <div class="coadmin-box mt-3" formArrayName="securityDetails"
              *ngFor="let group of securityDetails.controls; let i=index">
              <div [formGroupName]="i">
                <div class="row">
                  <div class="col-9">
                    <h1 class="font-bold">Security {{i+1}}</h1>
                  </div>
                  <div class="col-3">
                    <button type="button" (click)="clearSecurityDetail(i)" [disabled]="isDisabledSubmit">Clear</button>
                    <button *ngIf="group.value.securityName && group.value.securityMobile" type="button"
                      (click)="generatepassword(group)" [disabled]="isDisabledSubmit">Generate New Password</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <input type="text" class="search-line  pl-4 placeholder-text" id="securityName-{{i}}"
                      formControlName="securityName" type="text" [placeholder]="!securityName ? 'Enter Name' : ''"
                      [ngClass]="securityName?'textbox-onselect':'textbox-style'" (click)="enterName('securityName')"
                      [readonly]="isDisabledSubmit">
                    <label *ngIf="securityName" class="form-lable">Full Name</label>
                    <!-- <div *ngIf="submitted && group.controls.securityName.errors" class="error-fields">
                      <div *ngIf="group.controls.securityName.errors.required">*Name is required</div>
                      <div *ngIf="group.controls.securityName.errors.pattern">*Name is Invalid</div>
                    </div> -->
                  </div>
                  <div class="col-4">
                    <input type="text" style="padding-left: 30px !important;" class="search-line  pl-4 placeholder-text"
                      id="securityMobile-{{i}}" formControlName="securityMobile" type="text"
                      [placeholder]="!securityMobile ? 'Enter Phone Number' : ''"
                      [ngClass]="securityMobile?'textbox-onselect':'textbox-style'"
                      (click)="enterName('securityMobile')" [readonly]="isDisabledSubmit">
                    <div class="unit" style="position: absolute;top: 0;margin-top: 17px;margin-left: 5px;">+91</div>
                    <label *ngIf="securityMobile" class="form-lable">Mobile Number</label>
                    <!-- <div *ngIf="submitted && group.controls.securityMobile.errors" class="error-fields">
                      <div *ngIf="group.controls.securityMobile.errors.required">*Phone is required</div>
                      <div *ngIf="group.controls.securityMobile.errors.pattern">*Phone is Invalid</div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <hr>
          </div>


          <div class="row mt-4">
            <div class="col-12">
              <h2 class="mb-0 pb-0">Admin Information(s)</h2>
            </div>
          </div>

          <div class="coadmin-box mt-3" formArrayName="users" *ngFor="let item of users.controls; let i=index">
            <div [formGroupName]="i">
              <div class="row ">
                <div class="col-11">
                  <h1 class="font-bold">Admin {{i+1}}</h1>
                </div>
                <div class="col-1"><button *ngIf="coadmins.length>1 && !(users.controls[i]['value']['userId'])"
                    type="button" (click)="removeCoadmin(item.coadminNo,i)">Clear</button></div>
              </div>

              <div class="mt-3 row" id="employeeType">
                <div class="col-5 d-flex">
                  <input type="radio" class=" mr-2 mt-1" value="a" name="type{{i}}"
                    (change)="onItemChange($event.target.value, i)" [checked]="emailCheck[i]=='a'"
                    [disabled]="isDisabledSubmit">
                  <label for="Internal employee" class="radio-label ">Internal employee</label>
                  <input type="radio" class=" mr-2 ml-5 mt-1" value="b" name="type{{i}}"
                    (change)="onItemChange($event.target.value, i)" [checked]="emailCheck[i]=='b'"
                    [disabled]="isDisabledSubmit">
                  <label for="External employee" class="radio-label">External employee</label>
                </div>
                <div class="col-7"></div>
              </div>

              <div class="row mt-3">
                <div class="col-4">
                  <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [placeholder]="!name ? 'Full Name' : ''"
                    (click)="enterName('name')" formControlName="name" (blur)="enterName('name')"
                    (ngModelChange)="inputModelChange(1,'name')" [readonly]="isDisabledSubmit">
                  <label *ngIf="name" class="form-lable">Full Name</label>
                  <div *ngIf="submitted && item.controls.name.errors" class="error-fields">
                    <div *ngIf="item.controls.name.errors.required">*Name is required</div>
                    <div *ngIf="item.controls.name.errors.pattern">*Name is Invalid</div>
                  </div>
                </div>
                <div class="col-4">
                  <input type="text" style="padding-left: 30px !important;"
                    [ngClass]="mobile?'textbox-onselect':'textbox-style'" class="search-line  pl-4 placeholder-text"
                    formControlName="phoneNumber" [placeholder]="!mobile ? 'Mobile Number' : ''"
                    (click)="enterName('mobile')" (blur)="enterName('mobile')"
                    (ngModelChange)="inputModelChange(1,'mobile')" [readonly]="isDisabledSubmit">
                  <div class="unit" style="position: absolute;top: 0;margin-top: 17px;">+91</div>
                  <label *ngIf="mobile" class="form-lable">Mobile Number</label>
                  <div *ngIf="submitted && item.controls.phoneNumber.errors" class="error-fields">
                    <div *ngIf="item.controls.phoneNumber.errors.required">*Mobile number is required</div>
                    <div *ngIf="item.controls.phoneNumber.errors.pattern">*Mobile number is invalid</div>
                  </div>
                </div>
                <div class="col-4">
                  <!-- <input type="text" [ngClass]="email?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [placeholder]="!email ? 'Email-ID' : ''"
                    (click)="enterName('email')" (blur)="enterName('email')" formControlName="email" (ngModelChange)="inputModelChange(1,'email')" *ngIf="emailCheck[i]=='b'"> -->
                  <!-- <input type="text" [ngClass]="email?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [placeholder]="!email ? 'Email-ID' : ''"
                    (click)="enterName('email')" (blur)="enterName('email')" formControlName="email" (ngModelChange)="inputModelChange(1,'email')" #input [appEmailRestricter]="emailCheck[i]" [changedVal]="item.controls.email.value">
                    <span id="clearBtn1" class="clearBtn show" *ngIf="emailCheck[i]=='a'">{{emailDisplay}}</span> -->
                  <input type="text" [ngClass]="email?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [placeholder]="!email ? 'Email-ID' : ''"
                    (click)="enterName('email')" (blur)="enterName('email')" formControlName="email"
                    (ngModelChange)="inputModelChange(1,'email')" #input [appEmailRestricter]="emailCheck[i]"
                    [changedVal]="item.controls.email.value" [readonly]="isDisabledSubmit">
                  <!-- <span id="clearBtn1" class="clearBtn show" *ngIf="emailCheck[i]=='a'">{{emailDisplay}}</span> -->
                  <span id="clearBtn1" class="clearBtn show" *ngIf="emailCheck[i]=='a' && emailDomains.length > 0">
                    <select class="selectDropdown" (change)="selectedEmailDomain(i,$event.target.value)"
                      formControlName="domainSelectedByUser">
                      <option *ngFor="let eDomain of emailDomains" [value]="eDomain"
                        [attr.selected]="((eDomain === selectedEmail[i]) ? 'selected': null)">{{eDomain}}</option>
                    </select>
                  </span>
                  <label *ngIf="email" class="form-lable">Email-ID</label>
                  <div *ngIf="submitted && item.controls.email.errors" class="error-fields">
                    <div *ngIf="item.controls.email.errors.required">*Email is required</div>
                    <div *ngIf="item.controls.email.errors.email">*Email is invalid</div>
                  </div>
                </div>
              </div>

            </div>
          </div>


          <div class="row mt-3">
            <div class="col-4">
              <button type="button" class="button-add-admin" (click)="addAdmin()" [disabled]="isDisabledSubmit">+ Add
                admin</button>
            </div>
            <div class="col-8"></div>
          </div>

          <hr>
          <div class="row">
            <div class="col-8"></div>
            <div class="col-2"><button [routerLink]="['/company']" class="cancel-button" type="button">Cancel</button>
            </div>
            <div class="col-2">
              <button class="save-button" type="submit" [disabled]="isDisabledSubmit"
                [ngClass]="{'disable-button': isDisabledSubmit}">
                Save
              </button>
            </div>
          </div>
        </form>

        <!-- <div class="row pr-4">
          <div class="col-9 text pt-3">{{list?.length}} Co-admin</div>


          <div class="col-3 d-flex justify-content-end ">
            <label class="check-container">
              <input type="checkbox">
              <span class="checkmark" style="margin-top: 13px;"></span>
            </label>
            <p class="pl-3 pt-3 text-select">select all</p>
            <div class="list-option pl-4" (click)="$event.stopPropagation();openOptionDrawer = !openOptionDrawer">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div *ngIf="openOptionDrawer" class="drawer-container">
                <div>
                  <p (click)="$event.stopPropagation()">Revoke co-admin access</p>
                </div>
              </div>
            </div>
          </div>



        </div>


        <ng-container *ngIf="list">
          <div class="mt-3" *ngFor='let item of list'>
            <list [list]='item'></list>
          </div>
        </ng-container> -->

      </div>
    </div>
  </div>
</div>